module.exports = __webpack_public_path__ + "static/media/tab.9a9d76fc.png";